module.exports = __webpack_public_path__ + "static/media/18ECA21.7e8a7534.jpg";